import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Clock, DollarSign, Loader2 } from 'lucide-react';
import { motion } from 'framer-motion';

const SuggestionCard = ({ suggestion, delay = 0, onBook, booking }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay }}
    >
      <Card className="h-full hover:shadow-lg transition-all duration-200">
        <CardContent className="p-5">
          <div className="flex items-start justify-between mb-3">
            <h3 className="font-semibold text-lg text-balance">{suggestion.title}</h3>
            <Badge variant="secondary" className="ml-2 shrink-0">
              {suggestion.category}
            </Badge>
          </div>
          
          <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
            {suggestion.description}
          </p>

          <div className="flex items-center gap-4 text-sm text-muted-foreground">
            {suggestion.duration && (
              <div className="flex items-center gap-1">
                <Clock className="w-4 h-4" />
                <span>{suggestion.duration}</span>
              </div>
            )}
            {suggestion.price && (
              <div className="flex items-center gap-1">
                <DollarSign className="w-4 h-4" />
                <span className="font-medium text-foreground">{suggestion.price}</span>
              </div>
            )}
          </div>

          {suggestion.priceTier && (
            <div className="mt-3 pt-3 border-t border-border/50">
              <span className="text-xs font-medium text-muted-foreground">
                {suggestion.priceTier} tier
              </span>
            </div>
          )}

          {onBook && (
            <Button
              type="button"
              onClick={() => onBook(suggestion)}
              disabled={booking}
              className="mt-4 w-full"
            >
              {booking ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
              Book
            </Button>
          )}
        </CardContent>
      </Card>
    </motion.div>
  );
};

export default SuggestionCard;
